import { trans } from 'utils/helpers/translation'
import swal from 'sweetalert2'

export const askToDelete = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('you_wont_be_able_to_revert_this'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_delete_it')
    })
}

export const irreversible = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('you_wont_be_able_to_revert_this'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}

export const areYouSure = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('you_really_want_to_process_this_action'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}

export const subscribeWarning = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('do_you_want_to_confirm_your_subscribe'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}

export const subscriptionCompleted = () => {
    return swal({
        title: trans('great'),
        text: trans('subscription_completed_check_your_email'),
        type: 'success',
        confirmButtonText: trans('ok')
    })
}

export const cancelAccountWarning = () => {
    return swal({
        title: trans('what_a_pity'),
        text: trans('do_you_really_want_to_cancel_your_subscribe'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}

export const subscriptionCanceled = () => {
    return swal({
        title: trans('what_a_pity'),
        text: trans('feel_free_to_get_back_whenever_you_want'),
        type: 'info',
        confirmButtonText: trans('ok')
    })
}

export const sendEmail = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('you_wont_be_able_to_revert_this'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_send_it')
    })
}

export const askToImport = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('you_wont_be_able_to_revert_this'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}

export const integrationLink = () => {
    return swal({
        title: trans('_integrations.activate'),
        text: trans('_integrations.rd_station.sweetalert.line_01'),
        type: 'success',
        confirmButtonText: trans('ok')
    })
}

export const askToRefreshKey = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('existing_zaps_must_be_updated'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}

export const askToDeleteSteps = () => {
    return swal({
        title: trans('are_you_sure'),
        text: trans('pipeline_step_has_bounds_with_deals_or_incoming'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#5fbeaa',
        cancelButtonColor: '#f05050',
        confirmButtonText: trans('yes_do_it')
    })
}



// WEBPACK FOOTER //
// ./src/utils/helpers/sweet-alert.js